import React from 'react'
import logo from '../components/globales/logoCamionSAFITE.png';

const Home = () => {
	return (
		<img src="/logosafite2.png" alt="" width={400} />
	)
}

export default Home;